export const GET_PROPERTIES_PATH = 'api/landlord/properties';
